import Vue from 'vue';

export class ServerCompany {

      /**
     * Изменение общих данных бейджа
     *
     * @param  company: { id, title, description }
     * @return id
     */
       public static update(company: any): Promise<any> {
        return new Promise((resolve, reject) => {
          Vue.axios({
            url: '/query',
            method: 'POST',
            data: `
                  {
                    "query": "mutation {
                      Company (
                          _id:\\"${ company._id }\\"
                          description: \\"${ company.description }\\"
                          title: \\"${ company.title }\\"
                      ) {
                          _id
                        }
                    }"
                  }
                `
          })
            .then((resp: any) => {
    
              if (resp.data.status == 'ok') {
                resolve(resp.data);
              }
    
            })
            .catch((err: any) => {
              reject(err);
            });
        })
      }

    /**
   * Получение баджа по ИД
   *
   * @param  companyId
   * @return Company
  */
     public static getCompanyById(companyId : any) {
      return new Promise((resolve, reject) => {
        Vue.axios({
          url: '/query',
          method: 'POST',
          data: `
                {
                  "query": "query {
                    Company (
                        _id:\\"${ companyId }\\"
                    ) {
                      _id
                      title
                      description
                      promo {
                        id
                        order
                        title
                        type
                        value
                      }
                      contacts {
                        id
                        order
                        title
                        type
                        value
                      }
                      locations {
                        _country
                        address
                        city
                        id
                        order
                        postcode
                        region
                        title
                      }
                  }}"
                }
              `
        })
          .then((resp: any) => {
            if (resp.data.status == 'ok') {
              resolve(resp.data);
            }
    
          })
          .catch((err: any) => {
            reject(err);
          });
      })
    }

  /**
   * Изменение общих данных бейджа
   *
   * @param  id - id компании, contacts : Array
   * @return id
  */
  public static editCompanyContacts(id: any, contacts: Array<any>):Promise<any> {
    return new Promise((resolve, reject) => {
      Vue.axios({
        url: '/query',
        method: 'POST',
        data: `
        {
          "query": "mutation {
            Company (
                _id:\\"${id}\\"
                contacts: ${ this.stringifyContacts(contacts) }
            ) {
              _id
            }
          }"
        }
      `
      })

      .then((resp: any) => {
        if (resp.data.status == 'ok') {
          resolve(resp.data);
        }
      })
      .catch((err: any) => {
        reject(err);
      });
    })
  }

  protected static stringifyContacts(contacts: Array<any>) {
    return '[' +
      contacts
        .reduce((str: string[], contact: any) => {
          str.push(`{
            id: \\"${contact.id}\\"
            order: ${contact.order}
            type: \\"${contact.type}\\"
            title: \\"${contact.title}\\"
            value: \\"${contact.value}\\"
          }`);
          return str;
        }, [])
        .join(',') + ']';
  }

  /**
   * Добавление промо
   *
   * @param  id, promo: { title, type, value}
   * @return id, promo
  */
       public static addPromo(companyId: any, promo: any): Promise<any> {
        return new Promise((resolve, reject) => {
          Vue.axios({
            url: '/query',
            method: 'POST',
            data: `
                  {
                    "query": "mutation {
                      Company (
                          _id:\\"${ companyId }\\"
                          promo: {
                            order: 1
                            title: \\"${ promo.title }\\"
                            type: \\"${ promo.type }\\"
                            value: \\"${ promo.value }\\"
                          }
                      ) {
                        _id
                        promo {
                          id
                          order
                          title
                          type
                          value
                        }
                    }}"
                  }
                `
          })
            .then((resp: any) => {
      
              if (resp.data.status == 'ok') {
                resolve(resp.data);
              }
      
            })
            .catch((err: any) => {
              reject(err);
            });
        })
      }
    
      /**
       * Удаление промо
       *
       * @param  id, promoId
       * @return id, promo
      */
      public static deletePromo(companyId: any, promoId: any): Promise<any> {
        return new Promise((resolve, reject) => {
          Vue.axios({
            url: '/query',
            method: 'POST',
            data: `
                  {
                    "query": "mutation {
                      Company (
                          _id:\\"${ companyId }\\"
                          promo: {
                            remove:\\"${ promoId }\\"
                          }
                      ) {
                        _id
                    }}"
                  }
                `
          })
            .then((resp: any) => {
      
              if (resp.data.status == 'ok') {
                resolve(resp.data);
              }
      
            })
            .catch((err: any) => {
              reject(err);
            });
        })
      }

    /**
     * Добавление контакта бейджа (телефон/email/сайт/соц. сеть)
     *
     * @param  companyId, contacts: { title, type, value } 
     * @return companyId, contacts
    */
     public static addContact(companyId: any, contacts: any): Promise<any> {
      return new Promise((resolve, reject) => {
        Vue.axios({
          url: '/query',
          method: 'POST',
          data: `
                {
                  "query": "mutation {
                    Company (
                        _id:\\"${companyId}\\"
                        contacts: {
                          order: 1
                          title: \\"${ contacts.title }\\"
                          type: \\"${ contacts.type }\\"
                          value: \\"${ contacts.value }\\"
                        }
                    ) {
                      _id
                      contacts {
                        id
                        order
                        title
                        type
                        value
                      }
                  }}"
                }
              `
        })
          .then((resp: any) => {
  
            if (resp.data.status == 'ok') {
              resolve(resp.data);
            }
  
          })
          .catch((err: any) => {
            reject(err);
          });
      })
    }
  
    /**
     * Изменение контакта бейджа (телефон/email/сайт/соц. сеть)
     *
     * @param companyId, contactId, contacts 
     * @return companyId, contacts
    */
    public static editContact(companyId: any, contactId: any, contacts: any): Promise<any> {
      return new Promise((resolve, reject) => {
        Vue.axios({
          url: '/query',
          method: 'POST',
          data: `
                {
                  "query": "mutation {
                    Company (
                        _id:\\"${companyId}\\"
                        contacts: {
                          id:\\"${contactId}\\"
                          order: 1
                          title: \\"${ contacts.title }\\"
                          type: \\"${ contacts.type }\\"
                          value: \\"${ contacts.value }\\"
                        }
                    ) {
                      _id
                      contacts {
                        id
                        order
                        title
                        type
                        value
                      }
                  }}"
                }
              `
        })
          .then((resp: any) => {
  
            if (resp.data.status == 'ok') {
              resolve(resp.data);
            }
  
          })
          .catch((err: any) => {
            reject(err);
          });
      })
    }
  
      /**
       * Удаление контакта бейджа (телефон/email/сайт/соц. сеть)
       *
       * @param  companyId, contactId
       * @return companyId, contacts
      */
    public static deleteContact(companyId: any, contactId: any): Promise<any> {
    return new Promise((resolve, reject) => {
      Vue.axios({
        url: '/query',
        method: 'POST',
        data: `
              {
                "query": "mutation {
                  Company (
                      _id:\\"${ companyId }\\"
                      contacts: {
                        remove:\\"${ contactId }\\"
                      }
                  ) {
                    _id
                    contacts {
                      id
                      order
                      title
                      type
                      value
                    }
                }}"
              }
            `
      })
        .then((resp: any) => {
  
          if (resp.data.status == 'ok') {
            resolve(resp.data);
          }
  
        })
        .catch((err: any) => {
          reject(err);
        });
    })
    }
  
    /**
     * Добавление контакта бейджа (адрес)
     *
     * @param  companyId, contacts: { title, type, value } 
     * @return companyId, contacts
    */
    public static addAddress(companyId: any, contacts: any): Promise<any> {
      return new Promise((resolve, reject) => {
        Vue.axios({
          url: '/query',
          method: 'POST',
          data: `
                {
                  "query": "mutation {
                    Company (
                        _id:\\"${companyId}\\"
                        locations: {
                          address: \\"${ contacts.address }\\"
                          city: \\"${ contacts.city }\\"
                          order: 1
                          _country: \\"${ contacts._country }\\"
                          postcode: \\"${ contacts.postcode }\\"
                          region: \\"${ contacts.region }\\"
                          title: \\"${ contacts.title }\\"
                        }
                    ) {
                      _id
                      locations {
                        address
                        city
                        _country
                        id
                        order
                        postcode
                        region
                        title
                      }
                  }}"
                }
              `
        })
          .then((resp: any) => {
  
            if (resp.data.status == 'ok') {
              resolve(resp.data);
            }
  
          })
          .catch((err: any) => {
            reject(err);
          });
      })
    }
  
    /**
     * Изменение контакта бейджа (адрес)
     *
     * @param companyId, contacts
     * @return companyId
    */
       public static editAddress(companyId: any, contacts: any): Promise<any> {
        return new Promise((resolve, reject) => {
          Vue.axios({
            url: '/query',
            method: 'POST',
            data: `
                  {
                    "query": "mutation {
                      Company (
                        _id:\\"${companyId}\\"
                        locations: {
                          id:\\"${contacts.id}\\"
                          address: \\"${ contacts.address }\\"
                          city: \\"${ contacts.city }\\"
                          order: 1
                          _country: \\"${ contacts._country }\\"
                          postcode: \\"${ contacts.postcode }\\"
                          region: \\"${ contacts.region }\\"
                          title: \\"${ contacts.title }\\"
                        }
                      ) {
                        _id
                        contacts {
                          id
                          order
                          title
                          type
                          value
                        }
                    }}"
                  }
                `
          })
            .then((resp: any) => {
    
              if (resp.data.status == 'ok') {
                resolve(resp.data);
              }
    
            })
            .catch((err: any) => {
              reject(err);
            });
        })
      }
  
    /**
     * Удаление адреса
     *
     * @param  companyId, addressId
     * @return companyId, location { address }
    */
    public static deleteAddress(companyId: any, addressId: any): Promise<any> {
      return new Promise((resolve, reject) => {
        Vue.axios({
          url: '/query',
          method: 'POST',
          data: `
                {
                  "query": "mutation {
                    Company (
                        _id:\\"${ companyId }\\"
                        locations: {
                          remove:\\"${ addressId }\\"
                        }
                    ) {
                      _id
                      locations {
                        address
                        city
                        _country
                        id
                        order
                        postcode
                        region
                        title
                      }
                  }}"
                }
              `
        })
        .then((resp: any) => {
  
          if (resp.data.status == 'ok') {
            resolve(resp.data);
          }
  
        })
        .catch((err: any) => {
          reject(err);
        });
      })
    }

}